module.exports = "<itpx-evaluation-learning-tile [deliverableStatus]=\"deliverableStatus\" [status]=\"status\" [target]=\"target\" [logo]=\"'instructorpackage.png'\" [name]=\"name\" [errorMessage]=\"errorMessage\"  [disabled]=\"deliverable.disabled\" [availableUntil]=\"deliverable.availableUntil\">\n\n    <links-section>\n        <a class=\"link-wrapper\" href=\"{{href}}\"><img class=\"link-action\" src=\"{{images}}/download.png\"/></a>\n    </links-section>\n\n</itpx-evaluation-learning-tile>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/content/ispring/tile.component.html
// module id = 880
// module chunks = 0